/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    bool, func, object, shape, string,
} from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import ReactMarkdown from 'react-markdown';
import { withStyles } from '@material-ui/styles';

const styles = (theme) => ({
    dialogContent: {
        fontSize: '.8em',
    },
    subscriptionMessage: {
        fontSize: '.9em',
        padding: '2em 0',
        margin: '1em 0',
        '& span': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    subscriptionDetailsContainer: {
        backgroundColor: '#F7F7F7',
        justifyContent: 'center',
    },
    subscriptionDetails: {
        flexWrap: 'wrap',
        display: 'flex',
        fontSize: 14,
        padding: '0 50px',
        margin: '0 auto',
        '@media screen and (max-width: 360px)': {
            padding: '0 0 0 50px',
            width: '100%',
        },
        '& ul': {
            marginBottom: 0,
            lineHeight: '20px',
            marginTop: 20,
            paddingLeft: 10,
            [theme.breakpoints.down('xs')]: {
                paddingLeft: 40,
                marginTop: 10,
            },

        },
        '& span': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    dialogHeading: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flex: '0 0 auto',
        '@media screen and (max-width: 600px)': {
            '& >div': {
                width: '80%',
            },
            '& h2': {
                fontSize: '17px',
            },
        },
    },
    closeButton: {
        padding: '16px 24px',
        '@media screen and (max-width: 600px)': {
            padding: '0 0 0 2px',
        },
    },
    closeBtn: {
        position: 'absolute',
        top: '0',
        right: '0',
    },
    popUpHeading: {
        textAlign: 'center',
        '& span': {
            fontSize: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '18px',
            },
        },
    },
    bottomContent: {
        margin: '0 auto',
        padding: '20px 0',
        fontSize: '20px',
        fontWeight: '600',
        color: theme.palette.black || '#000',
        textTransform: 'uppercase',
        textDecoration: 'underline',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    copyContent: {
        maxWidth: '274px',
        minWidth: '240px',
        padding: '22px 11px',
        '@media screen and (max-width: 1332px)': {
            maxWidth: '245px',
        },
        '@media screen and (max-width: 580px)': {
            minWidth: '0',
            maxWidth: '195px',
        },
        '@media screen and (max-width: 492px)': {
            maxWidth: '135px',
        },
        '& p': {
            margin: 0,
            fontSize: '13px',
        },
        '& h5': {
            fontSize: '20px',
            fontWeight: 700,
            margin: 0,
            '@media screen and (max-width: 600px)': {
                fontSize: '14px',
            },
        },
    },
    copyIcon: {
        height: '46px',
        '@media screen and (max-width: 492px)': {
            width: '44px',
            marginRight: '15px',
        },
    },
    tnc: {
        color: theme.palette.primary?.main,
        textAlign: 'center',
        padding: '20px 0',
        cursor: 'pointer',
    },
});

const renderers = (handleModal) => ({
    linkReference: (props) => {
        const { href, children } = props;
        if (href === '/terms-and-conditions-modal') {
            return (
                <span key={1} role="link" tabIndex={0} onClick={(e) => { handleModal(e, true); }} onKeyDown={(event) => { if (event.keycode === 13); }}>
                    {children}
                </span>
            );
        }
        return children;
    },
});

const TandCInformation = ({
    open, classes, data, userConfirmation, handleModal, copy,
}) => (
    <div id="terms_and_conditions">
        <ReactMarkdown source={copy} renderers={renderers(handleModal)} escapeHtml={false} />
        { open ? (
            <Dialog data-testid="subscription-terms-condition-modal" open={open}>
                <DialogTitle className={classes.popUpHeading} id="customized-dialog-title">
                    <span>Subscription Program Terms and Conditions</span>
                    <IconButton className={classes.closeBtn} aria-label="Close" onClick={(e) => { handleModal(e, false); }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <MuiDialogContent className={classes.root}>
                    <Typography gutterBottom className={classes.dialogContent}>
                        <ReactMarkdown source={data.terms} escapeHtml="false" />
                    </Typography>
                </MuiDialogContent>
                <DialogActions>
                    <IconButton id="accept-subscription-button" aria-label="close" className={classes.bottomContent} onClick={userConfirmation}>
                        <span>Close</span>
                    </IconButton>
                </DialogActions>
            </Dialog>
        ) : null }
    </div>
);

TandCInformation.propTypes = {
    open: bool.isRequired,
    classes: object.isRequired,
    data: shape({
        terms: string.isRequired,
    }).isRequired,
    userConfirmation: func.isRequired,
    handleModal: func.isRequired,
    copy: string.isRequired,
};

export default withStyles(styles)(TandCInformation);
